import { useState, useEffect } from "react";
import { customAuthAxios } from "../../utils/customAuthAxios";

type BlocksReserve = {
  restaurant_id: string;
  reserve_id: string;
  password: string;
};

export const useFetchBlocksReserveByRestaurantId = (restaurantId: string | undefined) => {
  const [reserveSetting, setReserveSetting] = useState<BlocksReserve | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchReserveSetting = async () => {
      if (!restaurantId) return;
      setIsLoading(true);
      try {
        const response = await customAuthAxios.get(`/blocks_reserve/get/${restaurantId}/`);
        setReserveSetting(response.data);
      } catch (error) {
        console.error("データ取得に失敗しました", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReserveSetting();
  }, [restaurantId]);

  return { reserveSetting, isLoading };
};